import React, { Component } from 'react';
import './css/Player.css';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


const styles = {
  player: {
    margin: '5px',
    width: '360px',
  },
  table: {
    maxWidth: '10'
  }
};

class Player extends Component {
  constructor(props) {
    super(props)

    this.state = {
      placingsExpanded: true,
      setCountExpanded: true
    }
  }

  render() {
    const { placingsExpanded, setCountExpanded } = this.state;
    const { classes, setWins, setLosses, placements } = this.props;

    let placementsView = placements.map((p) => {
      return (
        <TableRow key={p.tournament.name}>
          <TableCell>{p.placement}</TableCell>
          <TableCell>{p.tournament.name}</TableCell>
        </TableRow>
      );
    });

    let setCount = {}
    for (let i = 0; i < setWins.length; i++) {
      const loser = setWins[i].loser;
      if (!setCount.hasOwnProperty(loser.id)) {
        setCount[loser.id] = {opponentId: loser.id, opponentTag: loser.tag, tournament: setWins[i].tournament, wins: 1, losses: 0};
      } else {
        setCount[loser.id].wins += 1;
      }
    }

    for (let i = 0; i < setLosses.length; i++) {
      const winner = setLosses[i].winner;
      if (!setCount.hasOwnProperty(winner.id)) {
        setCount[winner.id] = {opponentId: winner.id, opponentTag: winner.tag, tournament: setLosses[i].tournament, wins: 0, losses: 1};
      } else {
        setCount[winner.id].losses += 1;
      }
    }

    let setCountView = Object.keys(setCount).map((key) => {
      const s = setCount[key];
      return (
        <TableRow key={s.opponentId}>
          <TableCell padding={'dense'}>{s.opponentTag}</TableCell>
          <TableCell padding={'dense'}>{s.wins}</TableCell>
          <TableCell padding={'dense'}>{s.losses}</TableCell>
        </TableRow>
      );
    });

    const cardHeaderTitle = this.props.ranking_number + " " + this.props.tag;

    return (
      <Card className={classes.player}>
        <CardHeader
          title={cardHeaderTitle}
        />
        <ExpansionPanel
          expanded={placingsExpanded}
          onChange={(e) => this.setState({placingsExpanded: !placingsExpanded})}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Placings</Typography>
          </ExpansionPanelSummary>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell numeric>Placement</TableCell>
                <TableCell>Tournament</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {placementsView}
            </TableBody>
          </Table>
        </ExpansionPanel>
        <ExpansionPanel
          expanded={setCountExpanded}
          onChange={(e) => this.setState({setCountExpanded: !setCountExpanded})}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Set Count</Typography>
          </ExpansionPanelSummary>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding={'dense'}>Vs</TableCell>
                <TableCell padding={'dense'}>Wins</TableCell>
                <TableCell padding={'dense'}>Losses</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {setCountView}
            </TableBody>
          </Table>
        </ExpansionPanel>
      </Card>
    );
  }
}

export default withStyles(styles)(Player);



// WEBPACK FOOTER //
// ./src/Player.js